import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        image: '',
        cover_photo: '',
        name: '',
        email: '',
        matricule: '',
        address: '',
        description: '',
        type: '',
        reference: '',
        shift: {
            start: '',
            end: '',
        },
        features: [],
        printers: [],
        decimal_format: 2,
    },
    reducers: {
        setCompany: (state, action) => {
            return {
                ...state,
                ...action.payload,
                decimal_format: action.payload.decimal_format ?? state.decimal_format ?? 2
            }
        },
    },
})

export const { setCompany } = sessionSlice.actions

export default sessionSlice.reducer
